
import {Component, Vue} from "vue-property-decorator";
import {ProgramPaths} from "@/enum/ProgramPaths";
import SayfaBilgiInfo from "@/components/SayfaBilgiInfo.vue";
import RaporOzetKarti from "@/components/rapor/RaporOzetKarti.vue";
import {sunucuExcelKaydet, sunucuExcelYokla as sunucuExcelYoklaOrtak} from "@/utils/sunucuExcelYoklama";

@Component({
  components: {SayfaBilgiInfo, RaporOzetKarti},
})

export default class RaporDetayView extends Vue {
  headers: Array<object> = [];
  items: Array<object> = [];
  isReady: boolean = false;
  raporAdi: string = "";
  programPaths = ProgramPaths;
  printMode = false;

  grafikTercihi: string = "kartlar";
  sunucuExcelDurum: string = "";
  // DEV-3350: tavan dolduğunda iş hâlâ sürüyor olabilir; anahtarı tutuyoruz ki
  // yeniden basışta yeni iş açılmasın, aynı iş yoklansın.
  sunucuExcelIsAnahtari: string = "";
  // DEV-3350: bu iş servis yolunda mı açıldı (bayrak + büro listesi açık). Servis
  // yolunda dosya ekranda inmez; hazır olunca zil bildirimi çıkar. Anahtarla
  // birlikte tutulur ki tavan sonrası yeniden yoklama da doğru yolu kullansın.
  sunucuExcelServisYolu: boolean = false;
  // DEV-3350: ekrandan çıkıldı mı; yoklama bunu görünce durur.
  sunucuExcelEkrandanCikildi: boolean = false;
  /** DEV-3350: ekran satır sınırı aşıldı mı (sunucu bildirir). */
  ekranKesildi = false;
  ekranSiniri = 0;

  /** Düğme kilitli mi: iş kuyrukta ya da hazırlanıyorken yeniden tıklanamaz. */
  get sunucuExcelMesgul(): boolean {
    return this.sunucuExcelDurum === "kuyrukta" || this.sunucuExcelDurum === "hazirlaniyor";
  }

  get sunucuExcelEtiketi(): string {
    // DEV-3350 A3: tüm etkin durumlar (kuyrukta/hazırlanıyor) için TEK nötr yazı.
    // "Sırada bekliyor…" ayrı gösterilince, API ara durumu geç tazelediğinde
    // buton dakikalarca orada takılı görünüyordu; kullanıcı için kuyruk ile
    // üretim ayrımı anlamlı değil.
    return this.sunucuExcelMesgul ? "Hazırlanıyor…" : "Excel";
  }

  // DEV-3097 — Excel'i sunucuda kuyruğa üretip indirir. DEV-3350: tek Excel yolu;
  // her boyutta sunucuda üretilir, dosya hazır olunca kendiliğinden iner.
  sunucudaExcel() {
    if (this.sunucuExcelMesgul) return;
    // Tavan dolduğunda tutulan anahtar varsa aynı işi yoklamaya devam et;
    // yeniden üretim isteği göndermeyiz. Hangi yolda açıldıysa (servis / eski)
    // o yolla devam edilir.
    if (this.sunucuExcelIsAnahtari) {
      this.sunucuExcelDurum = "kuyrukta";
      this.sunucuExcelYokla(this.sunucuExcelIsAnahtari, this.sunucuExcelServisYolu);
      return;
    }
    this.sunucuExcelDurum = "kuyrukta";
    this.sunucuExcelEkrandanCikildi = false;
    // DEV-3350: B-20 eşzamanlı Excel sınırına takılınca 429, servis kapalı/yoğun/
    // hata durumunda 503/500 döner. Genel hata kapısı bunları ham genel pencereyle
    // gösterirdi; bu istek için onları bastırıp API'nin açık mesajını veriyoruz.
    //
    // [dev-3350] PR #1712 yorumu 881813320 — bastırma statik bayrakla yapılıyordu:
    // export isteği sürerken 429/500/503 uyarıları UYGULAMA GENELİ kapanıyor, o anda
    // başka bir isteğin (ör. zilin 60 sn'lik /bildirim yoklaması) 500'ü mesaj basmadan
    // geçiyordu. axios'ta timeout kapalı (`plugins/axios.ts:27`), istek askıda kalırsa
    // pencerenin üst sınırı da yoktu. Artık liste yalnız bu isteğin config'inde duruyor;
    // global durum hiç değişmiyor.
    this.$http.get("/api/v1/rapor/" + this.$route.params.id + "/export", {sessizKodlar: [429, 500, 503]}).then((response: any) => {
      // [dev-3350] PR #1712 yorumu 881813404 — yanıt gövdesi BURADA doğrulanır.
      // Doğrulanmadan `response.data.is_key` okunduğunda, uç 200 döndüğü halde gövde
      // `data` kabı olmadan gelirsa TypeError doğuyor ve bu istisna hata yoluna
      // düşüp "Sunucuya ulaşılamadı" olarak raporlanıyordu (ağın kendisi sorunsuzdu).
      const govde = response && response.data ? response.data : null;
      const isKey = govde ? govde.is_key : "";
      if (!isKey) {
        // İş sunucuda açılmış olabilir; elimizde yoklayacak anahtar yok. Düğmeyi
        // açıp SEBEBİNİ söylüyoruz — "bağlantınızı kontrol edin" demek yanlış olurdu.
        this.sunucuExcelDurum = "";
        this.$toast.error("Excel isteği karşılandı ama iş anahtarı dönmedi; lütfen yöneticinize bildirin.");
        return;
      }
      this.sunucuExcelIsAnahtari = isKey;
      this.sunucuExcelServisYolu = govde.yol === "servis";
      if (this.sunucuExcelServisYolu) {
        // Yeni yol: dosya ekranda inmez; servis arka planda üretir, hazır olunca
        // zilde bildirim çıkar. DEV-3350 D5: başarı yanıtının "mesaj"ını satır içi
        // kutu olarak GÖSTERMEYİZ; aynı bilgi hem kutuda hem zilde çift çıkmasın.
        // Başlangıç yazısı + zil bildirimi yeter.
        this.$toast.info("Hazırlanıyor; hazır olunca zilde bildirim çıkar");
      }
      this.sunucuExcelYokla(isKey, this.sunucuExcelServisYolu);
    }, (hata: any) => {
      // [dev-3350] PR #1712 yorumu 881813404 — başarı ve hata yolları `.then(basari, hata)`
      // ile AYRILDI. Eskiden aynı zincirin `.catch`'i `.then` gövdesinde doğan istisnaları
      // de yakalıyordu: uç 200 döndüğü halde yanıtta `data` kabı yoksa
      // `response.data.is_key` TypeError atıyor, `hata.response` olmadığı için de
      // "Sunucuya ulaşılamadı" mesajı çıkıyordu. Oysa iş o anda sunucuda AÇILMIŞTIR;
      // anahtar da tutulmadığı için kullanıcı her yeniden basışta yeni iş kuyruğa
      // atar ve 429 tavanına takılır. Artık bu dal yalnız axios'un kendi hatalarını görür.
      // İstek düştü: iş açılmadı, tutulacak anahtar yok. Düğme tek Excel yolu
      // olduğu için kilitli kalırsa sayfa yenilenene kadar Excel alınamaz.
      this.sunucuExcelDurum = "";
      const durum = hata && hata.response ? hata.response.status : 0;
      // Hata yanıtları kapsız/düz gelir: "mesaj" üst düzeydedir (başarı yanıtının
      // aksine "data" kabında değil).
      const mesaj = hata && hata.response && hata.response.data ? hata.response.data.mesaj : "";
      if (durum === 429) {
        // DEV-3350 K2: 429'un iki ayrı sebebi var — "önceki isteğiniz işleniyor"
        // (kilit alınamadı) ve eşzamanlı sınır. API hangisi olduğunu "mesaj"da
        // söylüyor; onu göster, yoksa genel sınır metnine düş.
        this.$toast.warning(mesaj || "Aynı anda hazırlanabilecek Excel sayısına ulaştınız; birinin bitmesini bekleyin.");
      } else if (durum === 503 || durum === 500) {
        // DEV-3350 K3: servis kapalı/yoğun/hata. API bu uçta açık "mesaj" yolluyor;
        // genel 503/500 penceresi yerine onu göster. Mesaj yoksa anlaşılır metne düş.
        this.$toast.error(mesaj || (durum === 503
            ? "Excel hazırlama servisi şu anda hizmet veremiyor; lütfen daha sonra tekrar deneyin."
            : "Excel hazırlanırken bir sorun oluştu; lütfen tekrar deneyin."));
      } else if (!hata || !hata.response) {
        // DEV-3350 A4: yanıtsız hata (ağ kopması/zaman aşımı). error.response
        // olmadığı için genel kapı mesaj gösteremez; eskiden buton sessizce
        // açılıp bırakılıyordu. Kendi açık mesajımızı veriyoruz.
        this.$toast.error("Sunucuya ulaşılamadı; bağlantınızı kontrol edip tekrar deneyin.");
      }
      // Yanıtlı diğer HTTP hatalarının mesajını axios eklentisi gösteriyor.
    });
  }

  // DEV-3224 (TDT-3483) — yoklama mantığı ortak yardımcıda: "bulunamadi" hata
  // sayılmaz (iş kuyrukta sırasını bekliyor olabilir), tavan var (DEV-3350: 17 dk)
  // ve mesaj gerçekte ne olduğunu söyler.
  sunucuExcelYokla(isKey: string, servisYolu: boolean = false) {
    sunucuExcelYoklaOrtak({
      durumSor: () => this.$http.get("/api/v1/rapor-ai/excel-durum/" + isKey)
          .then((response: any) => {
            // Düğme etiketini gerçek duruma göre güncelle: "Sırada bekliyor…" / "Hazırlanıyor…"
            // DEV-3350 K7: servis yolu ara durumları (isleniyor/yukleniyor) de üretimdir;
            // bunları "hazirlaniyor"a eşleyerek düğme "Sırada bekliyor…"da takılı kalmasın.
            if (response.data.durum === "kuyrukta") {
              this.sunucuExcelDurum = "kuyrukta";
            } else if (response.data.durum === "hazirlaniyor"
                || response.data.durum === "isleniyor"
                || response.data.durum === "yukleniyor") {
              this.sunucuExcelDurum = "hazirlaniyor";
            }
            return response.data.durum;
          }),
      hazir: () => {
        this.sunucuExcelDurum = "";
        this.sunucuExcelIsAnahtari = "";
        if (servisYolu) {
          // Yeni yol: dosya burada inmez. Servis CDN'e yükledi, sonuç ucu zil
          // bildirimini yazdı; zili tazeleyip (60 sn yoklamayı beklemeden)
          // kullanıcıyı oraya yönlendiriyoruz. DEV-3350 A5: satır-içi "Rapor hazır…"
          // toast'ı KALDIRILDI; zil tazelenince bildirim kendi toast'ını atıyor,
          // ikisi birden çift mesaj oluyordu (başlangıçtaki çift mesaj D5'te
          // kaldırılmıştı, bitişte de aynısı).
          this.$root.$emit("bildirimleri-tazele");
          return;
        }
        // [dev-3350] PR #1712 kardeş tarama — bu yol hem bastırmasız hem catch'sizdi:
        // iş "hazir" deyip dosya bu arada silinirse kullanıcı ham "404 Sayfa Bulunamadı"
        // penceresi görüyor, açık mesaj hiç çıkmıyor, reddedilen söz de yakalanmıyordu.
        // Zil yoluyla aynı davranışa getirildi: bastırma yalnız bu isteğin config'inde,
        // mesajı biz veriyoruz.
        this.$http.get("/api/v1/rapor-ai/excel-indir/" + isKey, {responseType: "blob", sessizKodlar: [404, 409]})
            .then((govde: any) => {
              sunucuExcelKaydet(govde, this.raporAdi + ".xlsx", (mesaj: string) => this.$toast.error(mesaj));
            }, (hata: any) => {
              const kod = hata && hata.response ? hata.response.status : 0;
              if (kod === 404 || kod === 409) {
                this.$toast.error("Dosya bulunamadı ya da süresi doldu; raporu yeniden hazırlayın.");
              } else if (!hata || !hata.response) {
                this.$toast.error("Sunucuya ulaşılamadı; dosya indirilemedi.");
              }
            });
      },
      hata: (metin: string) => {
        this.sunucuExcelDurum = "";
        this.sunucuExcelIsAnahtari = "";
        // DEV-3350 A5: yalnız "hazir" satır-içi toast'ı kaldırıldı (zil kendi toast'ını
        // atıyor). "hata"da zil anında tazelenmez (60 sn yoklama), kullanıcı geri
        // bildirimsiz kalmasın diye hata toast'ı HER İKİ yolda da kalır.
        this.$toast.error(metin);
      },
      zamanAsimi: (metin: string) => {
        // Tavan doldu ama iş sürüyor olabilir; anahtarı TUTUYORUZ ki yeniden
        // basışta aynı iş yoklansın, yeni iş açılmasın.
        this.sunucuExcelDurum = "";
        this.$toast.warning(metin);
      },
      // DEV-3350 D3/K6: ekrandan çıkışta yoklama YALNIZ servis yolunda durur.
      // Eski yolda (bayrak kapalı büro) T1/master davranışı korunur: zil yok,
      // dosya ekranda inmek zorunda; kullanıcı başka sayfaya geçse bile yoklama
      // sürer ve dosya kendiliğinden iner (yoksa iş ve anahtar kaybolurdu).
      durduruldu: () => servisYolu && this.sunucuExcelEkrandanCikildi,
    }, 0, servisYolu ? 5000 : 3000).then((sonuc) => {
      if (sonuc.tur === "istekHatasi") {
        // DEV-3350: durum sorusu düştü. Düğme açılır; anahtar kural gereği
        // TUTULUR (iş sürüyor olabilir, yeniden basış aynı işi yoklasın) —
        // ama ölü iş ve yanıtsız hata ayrı ele alınır.
        this.sunucuExcelDurum = "";
        const kod = sonuc.hata && (sonuc.hata as any).response
            ? (sonuc.hata as any).response.status : 0;
        if (kod === 404) {
          // DEV-3350 A2: durum ucu 404 → iş ölmüş. Anahtarı BIRAK ki yeniden
          // basışta ölü iş yoklanmak yerine YENİ iş açılsın.
          this.sunucuExcelIsAnahtari = "";
        } else if (kod === 0) {
          // DEV-3350 A4: yanıtsız hata (ağ/zaman aşımı). Genel kapı error.response
          // olmadığı için mesaj gösteremez; eskiden buton sessizce açılıyordu.
          // Kendi mesajımızı veriyoruz; anahtar tutulur (iş sürüyor olabilir).
          this.$toast.error("Sunucuya ulaşılamadı; rapor durumu alınamadı.");
        }
        // Yanıtlı diğer hataları (5xx vb.) axios eklentisi gösterir.
      } else if (sonuc.tur === "zamanAsimi" && sonuc.sonDurum === "bulunamadi") {
        // DEV-3350 A2: tavan "bulunamadi" ile dolduysa iş hiç oluşmamış/ölmüş
        // demektir. Anahtarı BIRAK; yeniden basış ölü işi yoklamasın, yeni iş açsın.
        this.sunucuExcelIsAnahtari = "";
      }
      // "iptal": ekrandan çıkıldı; durum zaten beforeDestroy'da bırakılıyor.
    });
  }

  // DEV-3011 — detay kipi satırları açılır-kapanır: ana satır (ilk kolonu dolu)
  // + altındaki kopya satırlar (detaylar) gruplanır; kullanıcı isterse açar.
  acikGruplar: { [grup: number]: boolean } = {};

  get ilkKolonKodu(): string {
    return this.headers.length ? (this.headers[0] as any).value : "";
  }

  get detayliMi(): boolean {
    if (!this.isReady || !this.ilkKolonKodu) return false;
    return this.items.some((satir: any) => satir[this.ilkKolonKodu] === null
        || satir[this.ilkKolonKodu] === undefined);
  }

  // DEV-3224 (TDT-3492) — sıralama durumu. Detay kipinde sıralamayı Vuetify'a
  // bırakmıyoruz: düz listeyi sıralasa dosya satırı ile detay satırları
  // birbirinden kopardı (ölçüldü: satırların %63'ü dosya alanı boş). Bunun yerine
  // DOSYALAR sıralanıyor, her dosya detaylarıyla birlikte taşınıyor.
  siralamaKolonu: string[] = [];
  siralamaTers: boolean[] = [];

  /** Vuetify'ın kendi sıralamasını devre dışı bırakır; sıra gorunurSatirlar'da kurulur. */
  siralamayiDevralt(items: Array<object>): Array<object> {
    return items;
  }

  /** Türkçe sıralama; sayı ve gg/aa/yyyy tarihi metin gibi değil değerince sıralanır. */
  private static degerKarsilastir(a: any, b: any): number {
    const bosA = a === null || a === undefined || a === '';
    const bosB = b === null || b === undefined || b === '';
    if (bosA && bosB) return 0;
    if (bosA) return 1; // boşlar daima sona
    if (bosB) return -1;

    const tarih = /^(\d{2})\/(\d{2})\/(\d{4})$/;
    const ta = tarih.exec(String(a));
    const tb = tarih.exec(String(b));
    if (ta && tb) {
      return (ta[3] + ta[2] + ta[1]).localeCompare(tb[3] + tb[2] + tb[1]);
    }

    const na = typeof a === 'number' ? a : Number(String(a).replace(',', '.'));
    const nb = typeof b === 'number' ? b : Number(String(b).replace(',', '.'));
    if (Number.isFinite(na) && Number.isFinite(nb)) return na - nb;

    return String(a).localeCompare(String(b), 'tr');
  }

  get satirGruplari(): Array<{ ana: any; detaylar: any[]; kimlik: number }> {
    const gruplar: Array<{ ana: any; detaylar: any[]; kimlik: number }> = [];
    this.items.forEach((satir: any, sira: number) => {
      const anaMi = satir[this.ilkKolonKodu] !== null && satir[this.ilkKolonKodu] !== undefined;
      if (anaMi || gruplar.length === 0) {
        // kimlik = kaynak listedeki konum; sıralama değişse de açık/kapalı
        // durumu doğru gruba bağlı kalsın diye indeks yerine bu kullanılıyor.
        gruplar.push({ana: satir, detaylar: [], kimlik: sira});
      } else {
        gruplar[gruplar.length - 1].detaylar.push(satir);
      }
    });
    return gruplar;
  }

  /** Dosyalar seçili kolona göre sıralı; detaylar dosyasıyla birlikte taşınır. */
  private siraliGruplar(): Array<{ ana: any; detaylar: any[]; kimlik: number }> {
    const gruplar = [...this.satirGruplari];
    const kolon = this.siralamaKolonu[0];
    if (!kolon) {
      return gruplar;
    }
    const ters = this.siralamaTers[0] === true;
    gruplar.sort((a, b) => {
      const fark = RaporDetayView.degerKarsilastir(a.ana[kolon], b.ana[kolon]);
      return ters ? -fark : fark;
    });
    return gruplar;
  }

  get gorunurSatirlar(): Array<object> {
    if (!this.detayliMi || this.printMode) return this.items;

    const sonuc: Array<object> = [];
    this.siraliGruplar().forEach((grup) => {
      sonuc.push({...grup.ana, __grup: grup.kimlik, __detaySayisi: grup.detaylar.length});
      if (this.acikGruplar[grup.kimlik]) {
        grup.detaylar.forEach(d => sonuc.push(d));
      }
    });
    return sonuc;
  }

  get tabloBasliklari(): Array<object> {
    if (!this.detayliMi) return this.headers;
    return [{text: "Detay", value: "__detay", sortable: false, width: 78, align: "center"}, ...this.headers];
  }

  grupToggle(grup: number) {
    this.$set(this.acikGruplar, grup, !this.acikGruplar[grup]);
  }

  // DEV-3011 — grafik (bar/pie): raporda MEVCUT ilk kategorik alanın dağılımı.
  // Detay kipinin kopya satırlarında kategorik alanlar boş olduğundan sayım
  // kendiliğinden dosya bazlı kalır.
  private static readonly KATEGORIK_KODLAR: Array<{ kod: string; baslik: string }> = [
    {kod: "takip_durumu", baslik: "Dosya Durumu"},
    {kod: "takip_tipi_aciklama", baslik: "Takip Tipi"},
    {kod: "takip_yolu_isim", baslik: "Takip Yolu"},
    {kod: "tahsilat_turu", baslik: "Tahsilat Türü"},
    {kod: "masraf_cesidi", baslik: "Masraf Çeşidi"},
    {kod: "icra_dairesi", baslik: "İcra Dairesi"},
    {kod: "dosya_sorumlusu", baslik: "Dosya Sorumlusu"},
  ];

  /** Grafiğin gruplandığı kategorik alan; rapora böyle bir alan girmemişse grafik yok. */
  get grafikAlani(): { kod: string; baslik: string } | null {
    if (this.grafikTercihi !== "bar" && this.grafikTercihi !== "pie") return null;
    if (!this.isReady || this.items.length === 0) return null;
    const kodlar = this.headers.map((h: any) => h.value);
    return RaporDetayView.KATEGORIK_KODLAR.find(k => kodlar.indexOf(k.kod) > -1) || null;
  }

  /**
   * Dağılım büyükten küçüğe sıralanır; ilk 8 kategori gösterilir, kalanlar
   * "Diğer" altında toplanır. (Ölçüldü: icra dairesi gibi alanlarda 40+ kategori
   * çıkabiliyor ve grafik okunamaz hale geliyordu.)
   */
  private static readonly GRAFIK_KATEGORI_SINIRI = 8;

  get grafikSerisi(): { etiketler: string[]; degerler: number[]; toplam: number } | null {
    const aday = this.grafikAlani;
    if (!aday) return null;
    const sayim: { [etiket: string]: number } = {};
    let toplam = 0;
    this.items.forEach((satir: any) => {
      const deger = satir[aday.kod];
      if (deger === null || deger === undefined || deger === "") return;
      const etiket = String(deger).split("\n")[0];
      sayim[etiket] = (sayim[etiket] || 0) + 1;
      toplam++;
    });
    let etiketler = Object.keys(sayim).sort((a, b) => sayim[b] - sayim[a]);
    if (etiketler.length === 0) return null;
    let degerler = etiketler.map(e => sayim[e]);
    const sinir = RaporDetayView.GRAFIK_KATEGORI_SINIRI;
    if (etiketler.length > sinir) {
      const kalan = degerler.slice(sinir).reduce((t, v) => t + v, 0);
      etiketler = etiketler.slice(0, sinir).concat(["Diğer (" + (Object.keys(sayim).length - sinir) + ")"]);
      degerler = degerler.slice(0, sinir).concat([kalan]);
    }
    return {etiketler, degerler, toplam};
  }

  get grafikBaslik(): string {
    const aday = this.grafikAlani;
    return aday ? aday.baslik + " Dağılımı" : "";
  }

  get grafikAltBaslik(): string {
    const seri = this.grafikSerisi;
    if (!seri) return "";
    // Detay kipinde kopya satırlarda kategorik alan boş kalır; grafik yalnız
    // değeri olan satırları sayar. Üstteki "N kayıt" ile karışmasın diye açıkça yazılır.
    return "değeri olan " + seri.toplam + " kayıt · " + seri.etiketler.length + " kategori";
  }

  /** Grafik renkleri temadan gelir; ürün teması değişince grafik de değişir. */
  get grafikRenkleri(): string[] {
    const stil = getComputedStyle(document.documentElement);
    const oku = (ad: string, varsayilan: string) => (stil.getPropertyValue(ad) || "").trim() || varsayilan;
    return [
      oku("--primary", "#9d7ae8"),
      oku("--chart-2", "#33c481"),
      oku("--chart-3", "#ffa826"),
      oku("--chart-4", "#f45150"),
      oku("--chart-5", "#00bbd4"),
      oku("--primary-lighten-2", "#c0a8f0"),
      oku("--primary-darken-2", "#6a3fc0"),
      "#98a2b3",
      "#cbd5e1",
    ];
  }

  /** Grafiğin altındaki okunur döküm: etiket · adet · yüzde */
  get grafikDagilim(): Array<{ etiket: string; deger: number; yuzde: string; renk: string }> {
    const seri = this.grafikSerisi;
    if (!seri) return [];
    const renkler = this.grafikRenkleri;
    const toplam = seri.degerler.reduce((t, v) => t + v, 0) || 1;
    return seri.etiketler.map((etiket, i) => ({
      etiket,
      deger: seri.degerler[i],
      yuzde: "%" + Math.round((seri.degerler[i] / toplam) * 100),
      renk: renkler[i % renkler.length],
    }));
  }

  /** Yatay çubukta kategori sayısı arttıkça yükseklik büyür, çubuklar ezilmez. */
  get grafikYuksekligi(): number {
    if (this.grafikTercihi === "pie") return 280;
    const seri = this.grafikSerisi;
    const adet = seri ? seri.etiketler.length : 1;
    return Math.max(180, Math.min(420, 60 + adet * 34));
  }

  get grafikAyarlari(): object {
    const seri = this.grafikSerisi;
    const etiketler = seri ? seri.etiketler : [];
    const renkler = this.grafikRenkleri;
    if (this.grafikTercihi === "pie") {
      return {
        chart: {toolbar: {show: false}, fontFamily: "inherit"},
        labels: etiketler,
        colors: renkler,
        legend: {show: false},
        stroke: {width: 2, colors: ["#fff"]},
        dataLabels: {enabled: true, formatter: (v: number) => Math.round(v) + "%"},
        plotOptions: {pie: {donut: {size: "62%"}}},
        tooltip: {y: {formatter: (v: number) => v + " kayıt"}},
      };
    }
    // Kategori adları uzun olabildiği için yatay çubuk: etiketler kırpılmadan okunur
    return {
      chart: {toolbar: {show: false}, fontFamily: "inherit"},
      colors: renkler,
      plotOptions: {bar: {borderRadius: 4, horizontal: true, barHeight: "62%", distributed: true}},
      xaxis: {categories: etiketler, labels: {style: {fontSize: "12px"}}},
      yaxis: {labels: {style: {fontSize: "12px"}, maxWidth: 220}},
      grid: {borderColor: "rgba(0,0,0,.06)", xaxis: {lines: {show: true}}, yaxis: {lines: {show: false}}},
      legend: {show: false},
      dataLabels: {enabled: true, style: {fontSize: "12px", fontWeight: 700, colors: ["#fff"]}},
      tooltip: {y: {formatter: (v: number) => v + " kayıt"}},
    };
  }

  // DEV-3011 — sonuç üstünde özet kartları. Yalnız rapora eklenmiş parasal
  // toplam kolonlarından üretilir; kolon yoksa kart da yok.
  private static readonly OZET_KOLONLARI: Array<{ kod: string; baslik: string }> = [
    {kod: "takip_toplami", baslik: "Toplam Takip"},
    {kod: "genel_toplam", baslik: "Genel Toplam"},
    {kod: "tahsilat_toplami", baslik: "Tahsilat (Net)"},
    {kod: "tahsilat_toplami_brut", baslik: "Tahsilat (Brüt)"},
    {kod: "kalan_tutar", baslik: "Kalan Bakiye"},
    {kod: "masraf_toplami", baslik: "Toplam Masraf"},
  ];

  get ozetKartlari(): Array<{ baslik: string; deger: string; vurgulu: boolean; renk: string }> {
    if (!this.isReady || !this.items || this.items.length === 0) return [];
    const mevcutKodlar = this.headers.map((h: any) => h.value);
    const kartlar: Array<{ baslik: string; deger: string; vurgulu: boolean; renk: string }> = [];
    const toplamlar: { [kod: string]: number } = {};

    RaporDetayView.OZET_KOLONLARI.forEach((tanim) => {
      if (mevcutKodlar.indexOf(tanim.kod) === -1) return;
      let toplam = 0;
      let cokluParaBirimi = false;
      this.items.forEach((satir: any) => {
        const ham = satir[tanim.kod];
        if (ham === null || ham === undefined || ham === "") return;
        // Tahsilat ve asıl alacak hücreleri para birimi başına satır taşır
        // ("1000\n250"); farklı para birimlerini toplamak yanlış sonuç verir.
        const parcalar = String(ham).split("\n").filter((p: string) => p !== "");
        if (parcalar.length > 1) {
          cokluParaBirimi = true;
          return;
        }
        const sayi = parseFloat(parcalar[0]);
        if (!isNaN(sayi)) toplam += sayi;
      });
      if (cokluParaBirimi) {
        kartlar.push({baslik: tanim.baslik, deger: "çoklu para birimi", vurgulu: false, renk: ""});
        return;
      }
      toplamlar[tanim.kod] = toplam;
      kartlar.push({baslik: tanim.baslik, deger: this.tutarStr(toplam), vurgulu: false, renk: RaporDetayView.kartRengi(tanim.kod)});
    });

    // Tahsilat oranı: iki toplam da raporda varsa hesaplanır
    const takip = toplamlar["takip_toplami"] ?? toplamlar["genel_toplam"];
    // Oran net tahsilat üzerinden; rapora yalnız brüt eklendiyse ondan hesaplanır
    const tahsilat = toplamlar["tahsilat_toplami"] ?? toplamlar["tahsilat_toplami_brut"];
    if (takip !== undefined && tahsilat !== undefined && takip > 0) {
      kartlar.push({
        baslik: "Tahsilat Oranı",
        deger: "%" + Math.round((tahsilat / takip) * 100),
        vurgulu: true,
        renk: "",
      });
    }
    // Vurgulu kart (tahsilat oranı) her zaman görünsün: dördüncü sıraya alınır
    const vurgulu = kartlar.filter((k) => k.vurgulu);
    const digerleri = kartlar.filter((k) => !k.vurgulu);
    return digerleri.slice(0, 4 - vurgulu.length).concat(vurgulu);
  }

  /** Tahsilat olumlu, kalan bakiye olumsuz okunur; diğerleri nötr. */
  private static kartRengi(kod: string): string {
    if (kod === "tahsilat_toplami" || kod === "tahsilat_toplami_brut") return "olumlu";
    if (kod === "kalan_tutar") return "olumsuz";
    return "";
  }

  private tutarStr(deger: number): string {
    return deger.toLocaleString("tr-TR", {minimumFractionDigits: 2, maximumFractionDigits: 2}) + " TL";
  }

  oncekiSayfa(){
    this.$router.push(this.programPaths.ofispro + '/raporlar')
  }
  mounted() {
    this.isReady = false;
    this.load();
  }

  beforeDestroy() {
    // DEV-3350: ekrandan çıkıldı işareti. Servis yolunda yoklama bunu görünce
    // durur (yok edilmiş bileşene durum sorusu gitmesin). Eski yolda (D3/K6)
    // bu işaret yok sayılır; yoklama sürer ve dosya kendiliğinden iner.
    this.sunucuExcelEkrandanCikildi = true;
  }

  load() {
    this.$http.get('/api/v1/rapor/' + this.$route.params.id).then((response) => {
      this.raporAdi = response.data.isim;
      this.grafikTercihi = response.data.grafik_tercihi || "kartlar";
      response.data.alanlar.forEach((raporAlani: IRaporAlani) => {
        this.headers.push({text: raporAlani.rapor_alan.isim, value: raporAlani.rapor_alan.kod});
      });
      this.$http.post('/api/v1/rapor/' + this.$route.params.id + '/render').then((response: any) => {
        this.items = response.data;
        // DEV-3350: ekran satır sınırı aşıldıysa AÇIKÇA söyle. Kesilen sonucu
        // sessizce göstermek, kullanıcıya eksik raporu tam gibi gösterirdi.
        this.ekranKesildi = !!response.ekran_kesildi;
        this.ekranSiniri = response.ekran_siniri || 0;
        this.isReady = true;
      })
    })
  }

  ciktiAl() {
    this.printMode = true;
    this.$nextTick(() => {
      this.$helper.printComponent('rapor');
      this.printMode = false;
    });
  }
}

interface IRaporAlani {
  gosterim_sirasi: number,
  id: number,
  rapor_alan: IRaporAlan,
  rapor_alan_id: number,
  rapor_id: number
}

interface IRaporAlan {
  id: number,
  isim: string,
  kod: string,
  field: string,
  joins: string,
  kosul_input: string,
  kosul_olabilir_mi: boolean,
  kosul_operatorleri: Array<any>
}
